import { registerTicketView } from "@shared/components/tickets/ticketViewRegistry";
import { assetManagementTicketType } from "./constants";
import AssetManagementTicketView from "./components/AssetManagementTicketView.vue";

registerTicketView({
  twinTypePattern: assetManagementTicketType,
  component: AssetManagementTicketView,
});
